import { render, staticRenderFns } from "./LifestyleProgramsSettings.vue?vue&type=template&id=3cef289f&scoped=true"
import script from "./LifestyleProgramsSettings.ts?vue&type=script&lang=js&external"
export * from "./LifestyleProgramsSettings.ts?vue&type=script&lang=js&external"
import style0 from "./LifestyleProgramsSettings.scss?vue&type=style&index=0&id=3cef289f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef289f",
  null
  
)

export default component.exports